// 五行 / 吉凶 配色 —— 暗色金箔主题（与官网 website/ :root 同一套，为暗底提亮）
export const WX_COLOR = {
  木: '#4caf6d',
  火: '#e05244',
  土: '#c99a5b',
  金: '#8fa8b8',
  水: '#4a90d9',
};

// 十干五行（供天盘干/地盘干着色）
export const GAN_WX = {
  甲: '木', 乙: '木', 丙: '火', 丁: '火', 戊: '土',
  己: '土', 庚: '金', 辛: '金', 壬: '水', 癸: '水',
};

export const WX_BG = {
  木: 'rgba(76, 175, 109, .14)',
  火: 'rgba(224, 82, 68, .14)',
  土: 'rgba(201, 154, 91, .14)',
  金: 'rgba(143, 168, 184, .14)',
  水: 'rgba(74, 144, 217, .14)',
};

export const LUCK_COLOR = {
  吉: '#5fb98a',
  凶: '#e06055',
  平: '#e0a04a',
};

export const LUCK_BG = {
  吉: 'rgba(95, 185, 138, .12)',
  凶: 'rgba(224, 96, 85, .12)',
  平: 'rgba(224, 160, 74, .12)',
};

// 四害 配色
export const HARM_COLOR = {
  空亡: '#9c5cb8',
  门迫: '#e05244',
  击刑: '#ff7a5c',
  入墓: '#a08a5a',
};

export const HARM_LABEL = {
  空亡: '空',
  门迫: '迫',
  击刑: '刑',
  入墓: '墓',
};

// 干支四害状态配色：无四害＝主文字色 · 击刑＝朱 · 入墓＝土 · 刑+墓＝紫
export const HARM_STATE_COLOR = {
  none: '#f2eee3',
  xing: '#ff7a5c',
  mu: '#8a8478',
  xingmu: '#b07cc6',
};

// 门配色：正常＝主文字色 · 门迫＝朱
export const MEN_STATE_COLOR = {
  none: '#f2eee3',
  po: '#e05244',
};

// 九神盘太常（居中五）
export const TAI_CHANG_COLOR = '#b07cc6';
